const trimTrailingSlashes = (url: string) => url.replace(/\/+$/, '');

// Nos services composent leurs liens de téléchargement depuis leur `DownloadBaseUrl`. Quand cette
// base est restée sur l'origine interne, le lien prend la forme `{origine}/api/<ressource>/{id}/content/{empreinte}`
// — `file` et `asset` pour datarepo (RESTAPI-DATAREPO.md §2 « Les fichiers sont encapsulés »). Le
// segment `api` n'est jamais exposé publiquement : la passerelle monte chaque service sous son propre
// segment (`/datarepo`). Un lien consommé tel quel peut donc répondre 404.
//
// applicationform, lui, compose un lien public complet (`…/applicationform/file/{id}/content/{empreinte}`,
// RESTAPI-APPLICATIONFORM.md §3.2 « Le lien de téléchargement ») : sans segment `api`, il passe tel quel.
//
// On ne garde du lien que sa partie signifiante — le chemin de la ressource après `api/` — et on la
// recolle sur la base que le client connaît **pour cette ressource** : c'est elle qui dit quel service
// la sert. Le jour où les services composent une origine publique correcte, ce code devient un
// passe-plat sans qu'il y ait rien à changer.
const RELAY_SEGMENT = '/api/';

const BASE_BY_RESOURCE: ReadonlyMap<string, string> = new Map([
  ['file', trimTrailingSlashes(import.meta.env.VITE_DATAREPO_SERVICE_URL)],
  ['asset', trimTrailingSlashes(import.meta.env.VITE_DATAREPO_SERVICE_URL)],
]);

export function resolveDownloadUrl(downloadUrl: string): string {
  // Un document sans contenu n'a pas de fichier à offrir : le contrat rend une chaîne vide.
  if (!downloadUrl) return '';

  const relayIndex = downloadUrl.indexOf(RELAY_SEGMENT);
  if (relayIndex === -1) return downloadUrl;

  const resourcePath = downloadUrl.slice(relayIndex + RELAY_SEGMENT.length);
  const [resource] = resourcePath.split('/', 1);
  const base = BASE_BY_RESOURCE.get(resource);

  // Une ressource qu'aucun de nos services ne sert : on ne devine pas, on laisse le lien tel quel.
  return base ? `${base}/${resourcePath}` : downloadUrl;
}
